import React, { useState, useEffect, useRef } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import {
  Box,
  Stack,
  FormControlLabel,
  Radio,
  RadioGroup,
  Typography,
  Divider,
  Paper,
  FormControl,
} from "@mui/material";

//共通コンポーネント
import { Header, MainColorButton, Loading } from "../../components";
import { bottomButton } from "../../common/styles";
//子供コンポーネント
import TextBox from "./textBox";
import {
  ERROR,
  SELECT_CREDIT_CARD,
  PRESCRIPTION_HISTORY,
  CUSTOMER_RESULT,
  START_PAY,
} from "../../routes/path";
import { getPaymentInformation } from "../../server/axios";

/**
 * 決済処理中画面
 * @returns
 */
const MedicalAccount = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const firstRenderRef = useRef(true);
  //選択された決済方法を保存
  const [selectedPayment, setSelectedPayment] = useState();
  //Loadingコンポネント表示非表示state
  const [loadingOpen, setLoadingOpen] = useState(false);
  //決済方法
  const [paymentMethods, setPaymentMethods] = useState([]);

  const [amount, setAmount] = useState(0);
  const [tax, setTax] = useState(0);
  const [totalAmount, setTotalAmount] = useState(0);
  const [updateDatetime, setUpdateDatetime] = useState();
  const [gmoShopId, setGmoShopId] = useState();

  const [message, setMessage] = useState(false);

  const [receiptedNumber, setReceiptedNumber] = useState();
  const [custmerId, setcustmerId] = useState("");

  useEffect(() => {
    if (process.env.NODE_ENV === "development" && firstRenderRef.current) {
      firstRenderRef.current = false;
      return;
    }
    setLoadingOpen(true);
    const { search } = location;
    const getUrlParams = () => {
      const params = new URLSearchParams(search);
      return {
        receiptedNumber: params.get("receiptedNumber"),
        siteId: params.get("siteId"),
        customerId: params.get("customerId"),
        familyId: params.get("familyId"),
        message: params.get("message"),
      };
    };

    const {
      receiptedNumber = "",
      siteId = "",
      customerId = "",
      familyId = "",
      message = false,
    } = search ? getUrlParams() : {};

    if (!receiptedNumber || !siteId || !customerId || !familyId) {
      navigate(ERROR);
    }
    setReceiptedNumber(receiptedNumber);
    setcustmerId(customerId);
    setMessage(message);

    getPaymentInformation({
      receiptedNumber: receiptedNumber,
      siteId: siteId,
      customerId: customerId,
      familyId: familyId,
    }).then((res) => {
      if (res.data?.deleteFlg) {
        setLoadingOpen(false);
        navigate(CUSTOMER_RESULT, {
          state: {
            header: "お会計",
            message: "選択されたお申し込みは、取消されています。",
            destination: message ? "" : PRESCRIPTION_HISTORY,
          },
        });
        return;
      } else if (res.data?.paymentCompletedFlg) {
        setLoadingOpen(false);
        navigate(CUSTOMER_RESULT, {
          state: {
            header: "決済完了",
            message: "決済が完了しました。",
            destination: message ? "" : PRESCRIPTION_HISTORY,
          },
        });
        return;
      }

      if (res.data?.paymentMethods && res.data?.paymentMethods.length > 0) {
        setAmount(res.data.accountingAmountWithoutTax);
        setTax(res.data.accountingTax);
        setTotalAmount(
          res.data.accountingAmountWithoutTax + res.data.accountingTax
        );
        setUpdateDatetime(res.data.updateDatetime);
        setGmoShopId(res.data.gmoShopId);
        const tempPaymentMethods = res.data?.paymentMethods.map((p) => {
          if (p.code === "01") {
            return {
              ...p,
              subItem: (
                <Box paddingLeft="10%" marginTop="-2%" marginBottom="-10%">
                  <Typography>利用可能カード会社</Typography>
                  <Box width="95%">
                    <FormControl fullWidth>
                      <Paper elevation={0} variant="outlined">
                        <Stack paddingLeft="3%">
                          <Typography>VISA、MasterCard、JCB、</Typography>
                          <Typography>American Express、Diners Club</Typography>
                        </Stack>
                      </Paper>
                    </FormControl>
                  </Box>
                </Box>
              ),
            };
          } else {
            return p;
          }
        });
        setPaymentMethods(tempPaymentMethods);
      }
      setLoadingOpen(false);
    });
  }, []);

  return (
    <>
      <Loading open={loadingOpen} />
      <Header title="お会計" />
      {paymentMethods && paymentMethods.length > 0 && (
        <Box
          height="76vh"
          marginTop="9vh"
          width="90%"
          marginLeft="auto"
          marginRight="auto"
        >
          <Typography>金額をご確認のうえ、決済方法を選択して</Typography>
          <Typography>お会計をお願いします。</Typography>
          <Stack spacing="3%" marginTop="5%">
            <Stack>
              <TextBox name="ご請求額" amount={amount} />
              <TextBox name="消費税" amount={tax} />
            </Stack>
            <Divider sx={{ border: "1px solid" }} />
            <TextBox name="合計" amount={totalAmount} />
          </Stack>
          <Typography>決済手段</Typography>
          <Stack sx={{ height: "46vh", overflowY: "scroll" }}>
            <RadioGroup
              sx={{ marginLeft: "6%" }}
              onChange={(e) => setSelectedPayment(e.target.value)}
            >
              {paymentMethods.map((item, index) => (
                <Box key={index}>
                  <FormControlLabel
                    value={item.code}
                    control={<Radio />}
                    // checked={item.itemNo === selectedPayment}
                    label={item.name}
                  />
                  {item.subItem}
                </Box>
              ))}
            </RadioGroup>
          </Stack>
        </Box>
      )}
      <MainColorButton
        label="決済"
        onClick={() => {
          if (selectedPayment === "01") {
            navigate(SELECT_CREDIT_CARD, {
              state: {
                customerId: custmerId,
                paymentMethodClass: selectedPayment,
                receiptedNumber: receiptedNumber,
                destination: message ? "" : PRESCRIPTION_HISTORY,
                message: message,
                updateDatetime: updateDatetime,
                gmoShopId: gmoShopId,
              },
            });
          } else {
            const selectedPaymentName = paymentMethods.filter(
              (item) => item.code === selectedPayment
            )[0].name;
            navigate(START_PAY, {
              state: {
                header: selectedPaymentName,
                customerId: custmerId,
                paymentMethodClass: selectedPayment,
                receptedNumber: receiptedNumber,
                destination: message ? "" : PRESCRIPTION_HISTORY,
                message: message,
                updateDatetime: updateDatetime,
              },
            });
          }
        }}
        style={bottomButton}
        disabled={!selectedPayment}
      />
    </>
  );
};

export default MedicalAccount;
